import { NavLink } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";

function Home() {
  return (
    <div>
      <Header />
      <link rel="stylesheet" href="https://fonts.googleapis.com" />
      {/* <div className="my-4 bg-[#fafafa]"> */}
      <div className="pt-24 bg-[#fafafa]">
        <div className="flex flex-col items-center justify-center gap-2">
          <div className="my-4 flex flex-col items-center w-[80%] max-w-[900px] text-center max-md:w-[90%]">
            <h1 className="text-[#570033] text-5xl text-center mb-2.5 max-md:text-[2.5rem] max-[480px]:text-[2rem] font-bold">
              Your Personal Travel Companion, Anywhere.
            </h1>
            <p className="text-[#71717a] text-base text-center max-[480px]:text-[0.9rem]">
              Book rides, guides, and stays-all in one app.
            </p>
            <p className="text-[#71717a] text-base text-center max-[480px]:text-[0.9rem]">
              Travel stress-free with local experts by your sides.
            </p>
          </div>

          <div>
            <img src="/images/2.png" alt="Phone" />
          </div>

          <NavLink
            to="/waitlist"
            className="bg-[#570033] my-8 py-4 text-white border-none w-2/5 rounded-lg text-center no-underline"
          >
            Join The Waitlist
          </NavLink>
        </div>

        <div className="flex justify-around items-center my-4 flex-wrap bg-[#f1f1f1] p-4 max-md:gap-4">
          <img
            src="/images/google.png"
            alt="Google"
            className="	w-[10%] max-md:w-[12%]"
          />
          <img
            src="/images/facebook.png"
            alt="Facebook"
            className="	w-[10%] max-md:w-[12%]"
          />
          <img
            src="/images/youtube.png"
            alt="Youtube"
            className="	w-[10%] max-md:w-[12%]"
          />
          <img
            src="/images/webflow.png"
            alt="Webflow"
            className="	w-[10%] max-md:w-[12%]"
          />
          <img
            src="/images/masterwire.png"
            alt="Masterwire"
            className="	w-[10%] max-md:w-[12%]"
          />
          <img
            src="/images/dribbble.png"
            alt="Dribble"
            className="	w-[10%] max-md:w-[12%]"
          />
        </div>

        <div className="w-[80%] mx-auto">
          <div className="text-center my-12">
            <h2 className="text-[#61013b] text-[1.9rem]">How It Works</h2>
            <p className="text-zinc-500 text-[1.2rem]">
              One App, Three Essential Services.
            </p>
          </div>

          <div className="flex flex-col gap-8">
            <div className="rounded-2xl p-12 bg-[#61013b] text-white flex justify-between items-center gap-4 max-lg:p-8 max-lg:gap-4 max-md:flex-col max-md:text-center max-md:p-8 max-[480px]:p-6">
              {/* <div className="rounded-2xl px-12 py-28 bg-[#61013b] flex justify-between items-center max-lg:p-8 max-lg:gap-4 max-md:flex-col max-md:text-center max-md:p-8 max-[480px]:p-6"> */}
              <div className="text-white flex flex-col gap-2 w-[40%] max-md:w-full">
                <h2>Reliable Rides, Anytime</h2>
                <p>
                  Wherever you need to go, get there safety with professional
                  drivers and secure rides.
                </p>
                <p>. Available 24/7, anywhere</p>
                <p>. Trusted, verified drivers</p>
                <p>. Comfortable and hassle-free</p>

                {/* <button >Book a ride now</button> */}

                <NavLink
                  to="/waitlist"
                  className="bg-white px-8 py-[0.7rem] text-[#570033] border-none rounded-lg w-1/2 my-4 no-underline max-lg:w-1/2 max-md:w-[60%] max-md:mx-auto max-md:my-4 max-[480px]:w-[80%] max-[480px]:px-4 max-[480px]:py-2"
                >
                  Join The Waitlist
                </NavLink>
              </div>

              {/* <div className="rounded-2xl flex w-[40%] max-md:w-full"> */}
              <div className="rounded-2xl flex max-md:w-full">
                <img
                  src="/images/rac2.png"
                  alt="pulo travel"
                  // className="w-full rounded-2xl"
                  className="max-md:w-full rounded-2xl"
                />
              </div>
            </div>

            <div className="rounded-2xl p-12 bg-[#7b180b] flex justify-between items-center gap-4 max-lg:p-8 max-lg:gap-4 max-md:flex-col max-md:text-center max-md:p-8 max-[480px]:p-6">
              <div className="rounded-2xl flex max-md:w-full">
                <img
                  src="/images/car2.png"
                  alt="pulo travel"
                  className="max-md:w-full"
                />
              </div>

              <div className="text-white flex flex-col gap-2 w-[40%] max-md:w-full">
                <h2>Guides That Elevate Your Journey</h2>
                <p>
                  Experience more with local experts who know the best spots and
                  hidden gems.
                </p>
                <p>. Personalized recommendations</p>
                <p>. Seamless navigation</p>
                <p>. Local insights for a richer trip</p>

                {/* <button >Find a guide</button> */}

                <NavLink
                  to="/waitlist"
                  className="bg-white px-8 py-[0.7rem] text-[#570033] border-none rounded-lg w-1/2 my-4 no-underline max-lg:w-1/2 max-md:w-[60%] max-md:mx-auto max-md:my-4 max-[480px]:w-[80%] max-[480px]:px-4 max-[480px]:py-2"
                >
                  Join The Waitlist
                </NavLink>
              </div>
            </div>

            <div className="rounded-2xl p-12 bg-black text-white flex justify-between items-center gap-4 max-lg:p-8 max-lg:gap-4 max-md:flex-col max-md:text-center max-md:p-8 max-[480px]:p-6">
              <div className="text-white flex flex-col gap-2 w-[40%] max-md:w-full">
                <h2>Fast & Easy Booking</h2>
                <p>
                  Skip the hassle-reserve your ride, guide, or stay in seconds.
                </p>
                <p>1 Select your service</p>
                <p>2 Get instant pricing</p>
                <p>3 Confirm securely</p>

                {/* <button >Book now</button> */}

                <NavLink
                  to="/waitlist"
                  className="bg-white px-8 py-[0.7rem] text-[#570033] border-none rounded-lg w-1/2 my-4 no-underline max-lg:w-1/2 max-md:w-[60%] max-md:mx-auto max-md:my-4 max-[480px]:w-[80%] max-[480px]:px-4 max-[480px]:py-2"
                >
                  Join The Waitlist
                </NavLink>
              </div>

              <div className="rounded-2xl flex max-md:w-full">
                <img
                  src="/images/car3.png"
                  alt="pulo travel"
                  className="max-md:w-full"
                />
              </div>
            </div>

            <div className="rounded-2xl p-12 bg-[#3a2619] gap-4 flex justify-between items-center max-lg:p-8 max-lg:gap-4 max-md:flex-col max-md:text-center max-md:p-8 max-[480px]:p-6">
              <div className="rounded-2xl flex max-md:w-full">
                <img
                  src="/images/car4.png"
                  alt="pulo travel"
                  className="max-md:w-full"
                />
              </div>

              <div className="	text-white flex flex-col gap-2 w-[40%] max-md:w-full">
                <h2>Travel Worry-Free</h2>
                <p>From booking to arrival, we've got you covered.</p>
                <p>. Real-time tracking for full visibility</p>
                <p>. 24/7 support when you need it</p>
                <p>. Secure payments, hassle-free</p>

                {/* <button >Get Started</button> */}

                <NavLink
                  to="/waitlist"
                  className="bg-white px-8 py-[0.7rem] text-[#570033] border-none rounded-lg w-1/2 my-4 no-underline max-lg:w-1/2 max-md:w-[60%] max-md:mx-auto max-md:my-4 max-[480px]:w-[80%] max-[480px]:px-4 max-[480px]:py-2"
                >
                  Join The Waitlist
                </NavLink>
              </div>
            </div>
          </div>
        </div>

        <div className="	w-full py-8 my-16 bg-[#f1f1f1]">
          <div className="text-center my-12">
            <h2 className="text-[#61013b] text-[1.9rem]">Why Pulo</h2>
            <p className="text-zinc-500 text-[1.2rem]">
              More Than Just a Travel App..
            </p>
          </div>

          <div className="flex justify-between items-center mx-auto w-[75%] max-md:flex-col max-md:gap-8">
            <div className="w-[48%] flex flex-col gap-8 max-md:w-full">
              <div className="px-4 py-8 text-white rounded-lg flex gap-4 items-center bg-[#61013b]">
                {/* <img src="/images/map-pin.png" alt="map-pin" /> */}
                <span class="material-symbols-outlined">location_on</span>
                <div className="	flex flex-col gap-2">
                  <p>Local Knowledge:</p>
                  <p className="text-sm">
                    Handpicked guides who know every hidden spot.
                  </p>
                </div>
              </div>

              <div className="px-4 py-8 text-white rounded-lg flex gap-4 items-center bg-[#181717]">
                {/* <img src="/images/shield-check.png" alt="shield-check" /> */}
                <span class="material-symbols-outlined">verified_user</span>
                <div className="flex flex-col gap-2">
                  <p>Your Safety, Our Priority:</p>
                  <p className="text-sm">
                    Verified drivers, guides, and hosts.
                  </p>
                </div>
              </div>
            </div>

            <div className="w-[48%] flex flex-col gap-8 max-md:w-full">
              <div className="px-4 py-8 text-white rounded-lg flex gap-4 items-center bg-[#7b180b]">
                {/* <img src="/images/hand-coins.png" alt="hand-coins" /> */}
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-hand-coins-icon lucide-hand-coins"><path d="M11 15h2a2 2 0 1 0 0-4h-3c-.6 0-1.1.2-1.4.6L3 17"/><path d="m7 21 1.6-1.4c.3-.4.8-.6 1.4-.6h4c1.1 0 2.1-.4 2.8-1.2l4.6-4.4a2 2 0 0 0-2.75-2.91l-4.2 3.9"/><path d="m2 16 6 6"/><circle cx="16" cy="9" r="2.9"/><circle cx="6" cy="5" r="3"/></svg>
                <div className="	flex flex-col gap-2">
                  <p>No Surprises:</p>
                  <p className="text-sm">Upfront pricing, no hidden fees.</p>
                </div>
              </div>

              <div className="px-4 py-8 text-white rounded-lg flex gap-4 items-center bg-[#3a2619]">
                <span class="material-symbols-outlined">calendar_month</span>
                {/* <img src="/images/calendar-days.png" alt="calendar" /> */}
                <div className="	flex flex-col gap-2">
                  <p>Flexible Stays:</p>
                  <p className="text-sm">
                    Short term or long term rentals for any trip.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="w-[80%] mx-auto">
          <div className="text-center my-12">
            <h2 className="text-[#61013b] text-[1.9rem]">
              Featured Destinations
            </h2>
            <p className="text-zinc-500 text-[1.2rem]">
              Explore Top Cities with Local Experts..
            </p>
          </div>

          <div className="flex justify-between max-md:flex-col max-md:gap-4">
            <div className="flex flex-col gap-8 w-[48%] max-md:gap-4 max-md:w-full max-md:mx-auto">
              <div>
                <img
                  src="/images/tour1.png"
                  alt="destination"
                  className="w-full rounded-2xl max-md:rounded-md"
                />
              </div>

              <div>
                <img
                  src="/images/tour2.png"
                  alt="destination"
                  className="w-full rounded-2xl max-md:rounded-md"
                />
              </div>
            </div>

            <div className="	flex flex-col gap-8 w-[48%] max-md:gap-4 max-md:w-full max-md:mx-auto">
              <div>
                <img
                  src="/images/tour3.png"
                  alt="destination"
                  className="w-full rounded-2xl max-md:rounded-md"
                />
              </div>

              <div>
                <img
                  src="/images/tour4.png"
                  alt="destination"
                  className="w-full rounded-2xl max-md:rounded-md"
                />
              </div>
            </div>
          </div>
        </div>

        <div className="py-8 my-0 bg-[#f1f1f1]">
          <div className="text-center my-12">
            <h2 className="text-[#61013b] text-[1.9rem]">Testimonies</h2>
            <p className="	text-zinc-500 text-[1.2rem]">
              Real Client, Real Story
            </p>
          </div>

          {/* <div className="flex w-[90%] mx-auto gap-8 items-center max-md:rounded-md max-md:flex-col max-md:gap-8">
            <div className="flex flex-col p-10 rounded-2xl w-[35%] h-[30vh] bg-white shadow-lg gap-8 max-[1270px]:h-[70vh] max-md:w-full max-md:h-[33vh] max-[480px]:w-full max-[480px]:h-[60vh]">
              <div className="flex gap-4 items-center">
                <div className="w-10 h-10 flex justify-center items-center overflow-hidden rounded-full border-2 border-gray-300">
                  <img
                    src="/images/tour1.png"
                    alt="person"
                    className="w-full h-full object-cover rounded-full"
                  />
                </div>
                <div>
                  <h3>Emilia A.</h3>
                  <p className="	text-zinc-500 text-sm max-md:text-[1rem]">
                    Creative Director, PixelCraft
                  </p>
                </div>
              </div>

              <p>"Pulo made my trip effortless. My guide was amazing!"</p>
            </div>

            <div className="flex flex-col p-10 rounded-2xl w-[35%] h-[30vh] bg-white shadow-lg gap-8 max-[1270px]:h-[70vh] max-md:w-full max-md:h-[33vh] max-[480px]:w-full max-[480px]:h-[60vh]">
              <div className="flex gap-4 items-center">
                <div className="	w-10 h-10 flex justify-center items-center overflow-hidden rounded-full border-2 border-gray-300">
                  <img
                    src="/images/tour1.png"
                    alt="person"
                    className="w-full h-full object-cover rounded-full"
                  />
                </div>
                <div>
                  <h3>Jake T.</h3>
                  <p className="text-zinc-500 text-sm max-md:text-[1rem]">
                    Creative Director, PixelCraft
                  </p>
                </div>
              </div>

              <p>"Booking a ride and stay together saved me so much time!"</p>
            </div>

            <div className="flex flex-col p-10 rounded-2xl w-[35%] h-[30vh] bg-white shadow-lg gap-8 max-[1270px]:h-[70vh] max-md:w-full max-md:h-[33vh] max-[480px]:w-full max-[480px]:h-[60vh]">
              <div className="	flex gap-4 items-center">
                <div className="w-10 h-10 flex justify-center items-center overflow-hidden rounded-full border-2 border-gray-300">
                  <img
                    src="/images/tour1.png"
                    alt="person"
                    className="w-full h-full object-cover rounded-full"
                  />
                </div>
                <div>
                  <h3>Emily R.</h3>
                  <p className="	text-zinc-500 text-sm max-md:text-[1rem]">
                    Creative Director, PixelCraft
                  </p>
                </div>
              </div>

              <p>"I felt safe and supported in a new city."</p>
            </div>
          </div> */}

          <div className="flex flex-wrap justify-center w-[90%] mx-auto gap-6 md:gap-8 lg:gap-12">
            {[
              {
                name: "Emilia A.",
                text: "Pulo made my trip effortless. My guide was amazing!",
              },
              {
                name: "Jake T.",
                text: "Booking a ride and stay together saved me so much time!",
              },
              {
                name: "Emily R.",
                text: "I felt safe and supported in a new city.",
              },
            ].map((person, idx) => (
              <div
                key={idx}
                className="flex flex-col p-6 sm:p-8 md:p-10 rounded-xl sm:rounded-2xl w-full sm:w-[48%] lg:w-[30%] bg-white shadow-md gap-6"
              >
                <div className="flex gap-4 items-center">
                  <div className="w-10 h-10 flex justify-center items-center overflow-hidden rounded-full border-2 border-gray-300">
                    <img
                      src="/images/tour1.png"
                      alt={person.name}
                      className="w-full h-full object-cover rounded-full"
                    />
                  </div>
                  <div>
                    <h3 className="text-base font-semibold">{person.name}</h3>
                    <p className="text-zinc-500 text-sm">
                      Creative Director, PixelCraft
                    </p>
                  </div>
                </div>
                <p className="text-sm sm:text-base">"{person.text}"</p>
              </div>
            ))}
          </div>
        </div>

        <div className="p-20 bg-black flex gap-[3.5rem] justify-center items-center max-lg:p-8 max-lg:gap-4 max-md:flex-col max-md:text-center max-md:p-8 max-[480px]:p-6">
          <div className="text-white flex flex-col gap-2 w-[45%] max-md:w-full">
            <p className="text-[2.3rem] font-semibold max-md:w-full">
              Experience Effortless Travel with Pulo.
            </p>
            <p className="	text-[1.2rem]">
              Sign up today and unlock the future of travel with Pulo!
            </p>
            <NavLink
              to="/waitlist"
              className="bg-white px-8 py-[0.7rem] text-[#570033] border-none rounded-lg w-1/2 my-4 no-underline text-center max-lg:w-1/2 max-md:w-[60%] max-md:mx-auto max-md:my-4 max-[480px]:w-[80%] max-[480px]:px-4 max-[480px]:py-2"
            >
              Join The Waitlist
            </NavLink>
          </div>

          <div className="rounded-2xl flex w-[45%] max-md:w-full">
            <img
              src="/images/phonePulo.png"
              alt="pulo travel"
              className="w-full rounded-2xl"
            />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Home;
